var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pickUpAndReturn !== null && _vm.accessGranted)?_c('div',[_c('PickUpAndReturnForm',{attrs:{"errorsData":_vm.errorsData,"loading":_vm.loading},on:{"validate":_vm.createPickUpAndReturn,"cancel":_vm.cancel},model:{value:(_vm.pickUpAndReturn),callback:function ($$v) {_vm.pickUpAndReturn=$$v},expression:"pickUpAndReturn"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }